import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/services/authService"

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '/',
      //name: 'Admin',
      component: () => import('./layouts/main/Main.vue'),
      children: [{
          path: '',
          name: 'AdminResults',
          component: () => import('./views/admin/lotto/Results.vue'),
          meta: {
            rule: 'admin',
            pageTitle: 'จัดการผลหวย',
            title: 'Admin - Dow Jones TV'
          }
        },
        {
          path: '/profile',
          name: 'user-profile',
          component: () => import('./views/account/Profile.vue'),
          meta: {
            rule: 'admin',
            breadcrumb: [
              { title: 'หน้าแรก', url: '/' },
              { title: 'ตั้งค่าข้อมูลส่วนตัว', active: true },
            ],
            pageTitle: 'ข้อมูลส่วนตัว',
            title: 'ข้อมูลส่วนตัว'
          },
        },
        // Admin Routes
        {
          path: 'add-results',
          name: 'admin-add-results',
          component: () => import('./views/admin/lotto/AddResults.vue'),
          meta: {
            rule: 'admin',
            breadcrumb: [
              { title: 'หน้าแรก', url: '/' },
              { title: 'จัดการผลหวย', url: '/' },
              { title: 'ออกผลหวย', active: true },
            ],
            pageTitle: 'จัดการผลหวย',
            title: 'ออกผลหวย'
          }
        },
        {
          path: 'results/:resultId',
          name: 'admin-edit-results',
          component: () => import('./views/admin/lotto/EditResults.vue'),
          meta: {
            rule: 'admin',
            breadcrumb: [
              { title: 'หน้าแรก', url: '/' },
              { title: 'จัดการผลหวย', url: '/' },
              { title: 'แก้ไขผลหวย', active: true },
            ],
            pageTitle: 'จัดการผลหวย',
            title: 'แก้ไขผลหวย'
          }
        }
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [{
          path: '/login',
          name: 'auth-login',
          component: () => import('@/views/auth/Login.vue'),
          meta: {
            rule: 'public',
            title: 'Admin - Login!'
          }
        },
        {
          path: '/error-404',
          name: 'auth-error-404',
          component: () => import('@/views/auth/Error404.vue'),
          meta: {
            rule: 'public',
            title: 'not found 404'
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/error-404'
    }
  ],
})

router.beforeEach((to, from, next) => {

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // ถ้ามีการ Login เรียบร้อยแล้ว มาเข้าที่หน้า login ให้ redirect ไปที่หน้า Admin
  if (to.name === "auth-login" && auth.isLoggedIn()) {
    router.push({ name: 'AdminResults' })
    return
  } else
  if (to.meta.rule === 'admin' && !auth.isLoggedIn()) {
    router.push({ name: 'auth-login' })
    return
  } else
  if (to.meta.rule === 'public' || auth.isLoggedIn()) {
    return next()
  } else {
    router.push({ name: 'auth-login' })
    return
  }

});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
})

export default router
